import { GuxIcon } from "genesys-spark-components-react";
import "./ErrorStatement.less";
export function ErrorStatement({ errorMessage }: { errorMessage: string }) {
    return (
        <div className="ErrorStatement" data-testid="error-statement">
            <GuxIcon
                iconName="fa/hexagon-exclamation-solid"
                decorative={true}
            />
            <span role="alert">{errorMessage}</span>
        </div>
    );
}
